import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';
import './InitialTextTermsConditions.style.scss';

export const InitialTextTermsConditions = () => {
  return (
    <article className="initial-text-terms-conditions">
      <DynamicContent
        configPath={REMOTE_CONFIG_PATHS.TERMS_CONDITIONS.INITIAL_TEXT}
        renderAsHtml={true}
      />
    </article>
  );
};
